export function getLanguageCode(language: string | undefined): string {
  return language?.split('-')[0] ?? '';
}
